import React from 'react';
import Select from 'react-select';
// import PropTypes from 'prop-types';
import axios from 'axios';
import { kinetik_api_url } from '../../utilities/const';



class SelectPayers extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [
                { label: 'Data is loading..', value: '' }
            ],
            isDataUpdated: false,
        };
    }
    componentDidMount() {
        let URL = kinetik_api_url + '/payerlist/payers';

        axios.get(URL)
            .then((result) => {
                let filteredData = result.data.data.map((v, k) => {
                    return { label: v.payer_name, value: v.payer_id }
                });
                this.setState({
                    isDataUpdated: true,
                    data: filteredData
                });
            });

    }
    render() {
        let PayersUser = this.state.data;
        let selectedPayers = this.props.selectedPayers.map(v => v.label + ',  ');

        const TempData = JSON.parse(localStorage.getItem('tempOnboardingData'));
        let company_payers = TempData && TempData.company_payers;
        company_payers = company_payers !== "" && JSON.parse(company_payers);
        let payersToShow = [];
        if (company_payers) {
            company_payers.map(v => payersToShow.push({ label: v.label, value: v.value }));
        }

        return (
            <div className="brd_tab_cntnt">
                <span className="payers_title">
                    Select PAYERS you work with
            </span>
                <div className="brding_frm_ele fix_payers_margin">
                    <span>Select Payers</span>
                    <Select
                        closeMenuOnSelect={true}
                        isMulti
                        options={PayersUser}
                        className="select_payers_cls"
                        onChange={(val) => this.props.onSelectPayers(val)}
                        defaultValue={payersToShow}

                    />
                </div> <br />
                <div className="brding_frm_ele">
                    <span>Selected</span>
                    <p id="selectedPayers" className="items-selected" value={JSON.stringify(this.props.selectedPayers)}> {selectedPayers}</p>
                </div> <br />


            </div>
        )
    }
    
    
};

export default SelectPayers;


// WEBPACK FOOTER //
// ./src/app/setup_onboarding/comps/SelectPayers.js